import React from "react";
import ReactModal from "react-modal";
import cx from "classnames";
import stylesV2 from "./Modal.module.scss";
import stylesV3 from "./ModalV2.module.scss";
import { useLocation } from "react-router-dom";
import closeIcon from "images/close.svg";
import closeNewIcon from "images/closeNew.svg";
import { useSchedulingABVariant } from "../../features/scheduling/utils/useSchedulingABVariant";

interface ModalProps {
  closeOnOverlayClick?: boolean;
  isOpen: boolean;
  className?: string;
  contentclassName?: string;
  overlayClassName?: string;
  onRequestClose?: () => void; // This callback is called when the user hits esc or clicks outside of the modal.
  aria?: ReactModal.Aria;
  customCloseIcon?: boolean;
  hideClose?: boolean;
  dismissButtonAtTop?: boolean;
}
export const Modal: React.FC<ModalProps> = ({
  closeOnOverlayClick,
  isOpen,
  children,
  className,
  overlayClassName,
  contentclassName,
  onRequestClose,
  aria,
  customCloseIcon,
  hideClose,
  dismissButtonAtTop = false,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const dismissButtonClassName = cx(styles.dismissButton, {
    [styles.dismissButtonTop]: dismissButtonAtTop,
  });
  if (customCloseIcon) {
    return (
      <ReactModal
        aria={aria}
        isOpen={isOpen}
        className={cx(styles.modal, className)}
        overlayClassName={cx(styles.overlay, overlayClassName)}
        bodyOpenClassName={styles.bodyOpenClassName}
        onRequestClose={onRequestClose}
        contentLabel={"Modal dialog"}
        shouldCloseOnOverlayClick={closeOnOverlayClick}
      >
        <div className={styles.closeContainer}>
          <button className={dismissButtonClassName} onClick={onRequestClose}>
            Close
            <img src={closeNewIcon} alt="" className={styles.dismissIcon} />
          </button>
        </div>
        <div className={cx(styles.modalContent, contentclassName)}>
          {children}
        </div>
      </ReactModal>
    );
  } else {
    return (
      <ReactModal
        aria={aria}
        isOpen={isOpen}
        className={cx(styles.modal, className)}
        overlayClassName={cx(styles.overlay, overlayClassName)}
        bodyOpenClassName={styles.bodyOpenClassName}
        onRequestClose={onRequestClose}
        contentLabel={"Modal dialog"}
        shouldCloseOnOverlayClick={closeOnOverlayClick}
      >
        <div>
          {!hideClose && (
            <button className={dismissButtonClassName} onClick={onRequestClose}>
              Close
              <img src={closeNewIcon} alt="" className={styles.dismissIcon} />
            </button>
          )}
        </div>
        <div className={cx(styles.modalContent, contentclassName)}>
          {children}
        </div>
      </ReactModal>
    );
  }
};

export const ReviewModal: React.FC<ModalProps> = ({
  closeOnOverlayClick,
  isOpen,
  children,
  className,
  contentclassName,
  overlayClassName,
  onRequestClose,
  aria,
  customCloseIcon,
  hideClose,
  dismissButtonAtTop = false,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const dismissButtonClassName = cx(styles.dismissButton, {
    [styles.dismissButtonTop]: dismissButtonAtTop,
  });
  if (customCloseIcon) {
    return (
      <ReactModal
        aria={aria}
        isOpen={isOpen}
        className={cx(styles.modal, className)}
        overlayClassName={cx(styles.overlay, overlayClassName)}
        bodyOpenClassName={styles.bodyOpenClassName}
        onRequestClose={onRequestClose}
        contentLabel={"Modal dialog"}
        shouldCloseOnOverlayClick={closeOnOverlayClick}
      >
        <div className={styles.closeContainer}>
          <button className={dismissButtonClassName} onClick={onRequestClose}>
            Close
            <img src={closeNewIcon} alt="" className={styles.dismissIcon} />
          </button>
        </div>
        <div className={cx(styles.modalReviewContent, contentclassName)}>
          {children}
        </div>
      </ReactModal>
    );
  } else {
    return (
      <ReactModal
        aria={aria}
        isOpen={isOpen}
        className={cx(styles.modal, className)}
        overlayClassName={cx(styles.overlay, overlayClassName)}
        bodyOpenClassName={styles.bodyOpenClassName}
        onRequestClose={onRequestClose}
        contentLabel={"Modal dialog"}
        shouldCloseOnOverlayClick={closeOnOverlayClick}
      >
        <div>
          {!hideClose && (
            <button className={dismissButtonClassName} onClick={onRequestClose}>
              Close
              <img src={closeNewIcon} alt="" className={styles.dismissIcon} />
            </button>
          )}
        </div>
        <div className={cx(styles.modalReviewContent, contentclassName)}>
          {children}
        </div>
      </ReactModal>
    );
  }
};
